module.exports = __webpack_public_path__ + "02_face.4ac5244b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/02_face.png
// module id = ZGti
// module chunks = 0